import { TypeModel } from "./TypeModel";

export function CategoryDescription(data) {
    const { id, description, link, typeUniformCategoryFiles: files } = data;

    return {
        id,
        description: description || "",
        link: link || "",
        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        hasDescription: description || link || (files && files.length),
    };
}

export function CategoryModel(data, parentId) {
    const { id, name, parent_id, responsible_id, sub_categories, typeUniforms, isEmpty } = data;

    const descriptionModel = CategoryDescription(data);

    if (parent_id || parentId) {
        return {
            parentId: `${parentId || parent_id}`,

            id: `${id}`,
            name,
            isEmpty,
            responsible: responsible_id ? `${responsible_id}` : null,
            descriptionModel,

            isVisible: false,
            subCategories: [],
            types: (typeUniforms || []).map(TypeModel),
        };
    }

    return {
        isCategory: true,
        parentId: null,

        id: `${id}`,
        name,
        responsible: responsible_id ? `${responsible_id}` : null,
        descriptionModel,
        isEmpty,
        isVisible: false,
        subCategories: (sub_categories || []).map(CategoryModel, id),
        types: (typeUniforms || []).map(TypeModel),
    };
}

export function formatCategoryModel(data) {
    const { name, parentId, responsible, description, link, files, oldFiles } = data;

    return {
        name,
        parent_id: parentId,

        responsible_id: responsible,
        description,
        link,
        files,
        oldFiles,
    };
}

export function updateCategoryModel(model, data) {
    const { name, parentId, responsible, descriptionModel } = data;

    model.name = name;
    model.parentId = parentId;
    model.isCategory = !parentId;
    model.isSubCategory = !!parentId;
    model.responsible = responsible;
    model.descriptionModel = descriptionModel;

    return model;
}
